export default [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    component: (resolve) => require(['../views/index.vue'], resolve),
    children: [
      // {
      //   path: '',
      //   redirect: 'elementMenu'
      // },
      {
        path: 'welcome',
        title: 'welcome',
        name: 'welcome',
        component: (resolve) => require(['../views/welcome/index.vue'], resolve)
      },
      // 元件菜单
      {
        path: 'elementMenu',
        title: 'componentModule',
        name: 'componentMenu',
        component: (resolve) => require(['../views/elementMenu/index.vue'], resolve)
      },
      // 拆表元件列表
      {
        path: 'elementMenu2',
        title: 'componentModule',
        name: '拆表元件列表',
        component: (resolve) => require(['../views/elementMenu/index2.vue'], resolve)
      },
      // 账号管理
      {
        path: 'accounts',
        title: 'systemSettings',
        name: 'accountManagement',
        component: (resolve) => require(['../views/accounts/index.vue'], resolve)
      },
      // 权限管理
      {
        path: 'auth',
        title: 'systemSettings',
        name: 'permissionManagement',
        component: (resolve) => require(['../views/auth/index.vue'], resolve)
      },
      // 封装类型管理
      {
        path: 'encapsulationType',
        title: 'paramsManagement',
        name: 'encapsulationTypeManagement',
        component: (resolve) => require(['../views/encapsulationType/index.vue'], resolve)
      },
      // 制造商管理
      {
        path: 'manufacturer',
        title: 'paramsManagement',
        name: 'manufacturerManagement',
        component: (resolve) => require(['../views/manufacturer/index.vue'], resolve)
      },
      // 操作日志
      {
        path: 'log',
        title: 'systemSettings',
        name: 'operationLog',
        component: (resolve) => require(['../views/log/index.vue'], resolve)
      },
      {
        path: 'elementCreateReview',
        title: 'componentModule',
        name: 'componentCreationReview',
        component: (resolve) => require(['../views/elementCreateReview/index.vue'], resolve)
      },
      {
        path: 'componentMaterial',
        title: 'componentMaterial',
        name: 'componentMaterial',
        component: (resolve) => require(['../views/componentMaterial/index.vue'], resolve)
      },
      {
        path: 'elementConfiguration',
        title: 'clgl',
        name: 'elementConfiguration',
        component: (resolve) => require(['../views/elementConfiguration/index.vue'], resolve)
      },
      {
        path: 'componentParameters',
        title: 'componentParameters',
        name: 'componentParameters',
        component: (resolve) => require(['../views/componentParameters/index.vue'], resolve)
      },
      // {
      //   path: 'assignMaterials',
      //   title: 'clgl',
      //   name: 'assignMaterials',
      //   component: (resolve) => require(['../views/assignMaterials/index.vue'], resolve)
      // }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: (resolve) => require(['../views/login.vue'], resolve),
    meta: {
      nologin: true
    }
  }
];